import utils from "../../../src/js/utils";

var winesSlider = {
	el: document.querySelector(".wines-slider"),
	set: {
		slider: function () {
			var splide = new Splide(winesSlider.el, {
				lazyLoad: "nearby",
				speed: 1000,
				pagination: false,
				arrows: false,
				drag: true,
				autoWidth: true,
				easing: "ease",
				mediaQuery: "min",
				breakpoints: {
					1024: {
						perPage: 4,
						drag: false,
					},
					1600: {
						perPage: 5,
					},
					2000: {
						perPage: 6,
					},
				},
				i18n: {
					slideLabel: "%s di %s",
				},
			});

			//var progressBar = winesSlider.el.querySelector(".inner-progress");
			var nSlides = winesSlider.el.querySelectorAll(".wine").length;
			var bkg = winesSlider.el.querySelector(".inner-overflow");
			var manualMove = false;

			var translate = {
				total:
					winesSlider.el.querySelector(".splide__list").scrollWidth -
					utils.screen.width,
				pos: 0,
			};

			splide.on("mounted", function () {
				//winesSlider.set.progress(splide, progressBar, false);
				winesSlider.set.bkgCat.append(splide);
			});

			if (utils.screen.width > 1024) {
				gsap.timeline({
					scrollTrigger: {
						trigger: winesSlider.el,
						id: "wines-slider",
						start: "top top",
						end: "+=" + nSlides * 200,
						scrub: true,
						pin: true,
						onUpdate: function (self) {
							if (!manualMove) {
								//progressBar.style.transition = "none";
								bkg.style.transition = "none";
								manualMove = true;
							}
							var newPos = self.progress * translate.total * -1;
							splide.Components.Move.translate(newPos);
							//progressBar.style.transform = "scale(" + self.progress + ", 1)";

							translate.pos = splide.Components.Move.getPosition();
							winesSlider.set.bkgCat.animation(splide, bkg, translate);
						},
					},
				});

				const refreshObserver = new IntersectionObserver(function (entries) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting || entry.intersectionRatio > 0) {
							ScrollTrigger.getById("wines-slider").refresh();
							refreshObserver.unobserve(entry.target);
						}
					});
				});

				refreshObserver.observe(winesSlider.el);
			}

			splide.on("move", function () {
				if (manualMove) {
					//progressBar.style.transition = "";
					bkg.style.transition = "";
					manualMove = false;
				}

				// winesSlider.set.progress(splide, progressBar, false);
				winesSlider.set.bkgCat.animation(splide, bkg, false);
			});

			/* 
            
            splide.on("dragging", function () {
				if (!manualMove) {
					progressBar.style.transition = "none";
					bkg.style.transition = "none";
					manualMove = true;
				}
				translate.pos = splide.Components.Move.getPosition();

				winesSlider.set.progress(splide, progressBar, translate);
				winesSlider.set.bkgCat.animation(splide, bkg, translate);
			});

			var winesSliderScrollTrigger = ScrollTrigger.getById("wines-slider");

			splide.on("moved", function () {
				var totalHeight =
					winesSliderScrollTrigger.end - winesSliderScrollTrigger.start;
				var newPos = splide.Components.Move.getPosition() * -1;
				var newTop = (newPos * totalHeight) / translate.total;
				var top = winesSliderScrollTrigger.start;
				window.scrollTo({
					top: top + newTop,
					behavior: "instant",
				});
			});

            */

			splide.mount();
		},
		bkgCat: {
			diffRatio: utils.screen.width < 1024 ? 1 : 0.95,
			append: function (slider) {
				var cats = winesSlider.el.querySelectorAll("[data-cat]");
				var arrayCats = [];
				var parentCats = document.createDocumentFragment();
				var bkg = winesSlider.el.querySelector(".inner-overflow");
				utils.forEach(cats, function (index, cat) {
					var catValue = cat.getAttribute("data-cat");
					if (!arrayCats.includes(catValue)) {
						arrayCats.push(catValue);
					}
				});
				utils.forEach(arrayCats, function (index, singleCat) {
					var catLength = winesSlider.el.querySelectorAll(
						'[data-cat="' + singleCat + '"]'
					);
					var newCat = document.createElement("DIV");
					newCat.setAttribute("data-cat", singleCat);
					newCat.style.width =
						catLength.length *
							winesSlider.el.querySelector(".wine").offsetWidth *
							winesSlider.set.bkgCat.diffRatio +
						"px";
					parentCats.appendChild(newCat);
				});
				bkg.appendChild(parentCats);
				winesSlider.set.bkgCat.animation(slider, bkg, false);
			},
			animation: function (slider, el, translate) {
				if (!translate) {
					var end = slider.Components.Controller.getEnd();
					var progress = Math.min(slider.index / end, 1);
					el.style.transform =
						"translate3d(-" +
						(((el.offsetWidth - utils.screen.width) * progress) / 1) *
							winesSlider.set.bkgCat.diffRatio +
						"px,0,0)";
				} else {
					el.style.transform =
						"translate3d(-" +
						translate.pos * -1 * winesSlider.set.bkgCat.diffRatio +
						"px,0,0)";
				}
			},
		},
		/* 		progress: function (slider, progressBar, translate) {
			if (!translate) {
				var end = slider.Components.Controller.getEnd();
				var progress = Math.min(slider.index / end, 1);
				progressBar.style.transform = "scale(" + progress + ", 1)";
			} else {
				var progress = Math.min((-1 * translate.pos) / translate.total, 1);
				progressBar.style.transform = "scale(" + progress + ", 1)";
			}
		}, */
	},
	init: function () {
		if (winesSlider.el) {
			winesSlider.set.slider();
		}
	},
};

utils.domReady(function () {
	winesSlider.init();
});
